/** Shared Tailwind classes for tenant brand (`app.primary` / `--app-primary`). */

export const APP_FOCUS_RING =
  'focus:outline-none focus:ring-2 focus:ring-app-primary focus:border-transparent';

export const APP_FOCUS_WITHIN_RING =
  'focus-within:outline-none focus-within:ring-2 focus-within:ring-app-primary focus-within:border-transparent';

export const APP_CHECKBOX =
  'rounded border-app-border text-app-primary focus:ring-app-primary';

export const APP_RADIO = 'text-app-primary focus:ring-app-primary';

export const APP_LINK =
  'text-app-primary hover:underline dark:text-app-primary/80';

export const APP_TAB_ACTIVE =
  'bg-app-primary text-white shadow-sm';

export const APP_TAB_INACTIVE =
  'bg-app-surface-muted text-app-text-muted hover:bg-app-primary/10 dark:hover:bg-app-primary/15';

export const APP_CHIP_SELECTED =
  'bg-app-primary/15 text-app-primary border-app-primary/40 ring-1 ring-app-primary/25';

export const APP_CHIP_DEFAULT =
  'bg-app-surface text-app-text border-app-border hover:border-app-primary/30';

export const APP_PAGINATION_ACTIVE =
  'bg-app-primary text-white border-app-primary';

export const APP_PAGINATION_INACTIVE =
  'bg-app-surface text-app-text border-app-border hover:bg-app-primary/10';

export const APP_PROGRESS_TRACK = 'bg-app-primary/15 dark:bg-app-primary/20 overflow-hidden rounded-full';

export const APP_PROGRESS_FILL = 'h-full rounded-full bg-app-primary transition-all';

export const APP_STEP_ACTIVE = 'bg-app-primary text-white';

export const APP_STEP_COMPLETE = 'bg-app-primary/15 text-app-primary dark:bg-app-primary/20';

export const APP_STEP_PENDING =
  'bg-app-surface-muted text-app-text-muted dark:bg-gray-800 dark:text-gray-400';

export const APP_TABLE_ROW_SELECTED = 'bg-app-primary/10 dark:bg-app-primary/15';

export const APP_SPINNER = 'animate-spin rounded-full border-b-2 border-app-primary';

export const APP_BADGE_PRIMARY =
  'bg-app-primary/15 text-app-primary dark:bg-app-primary/20 dark:text-app-primary/90';

export const APP_BUTTON_OUTLINE =
  'border-2 border-app-primary text-app-primary hover:bg-app-primary/10 dark:hover:bg-app-primary/15 focus:ring-app-primary';

export const APP_BUTTON_GHOST =
  'text-app-primary hover:bg-app-primary/10 dark:hover:bg-app-primary/15 focus:ring-app-primary';
